import { triggerCustomerIoOnboardingPaymentFailed } from "@/features/analytics/triggers/customer-io/onboarding";
import { categoriesToGoogleTagManagerProducts } from "@/features/analytics/utils";
import type { OnboardingUser } from "@/features/onboarding/models";
import type { CategoryWithSelectedProduct } from "@/features/products/models";
import { calculateTotal } from "@/features/products/utils";
import { CURRENCY } from "@/shared/models";
import type { EventPrefix, GoogleTagManagerEventDetails } from "../models";
import { EVENT_PREFIX, GOOGLE_TAG_MANAGER_EVENT } from "../models";
import { triggerGoogleTagManagerTracking } from "../triggers/google-tag-manager";

interface TrackPaymentFailedParams {
  user: OnboardingUser;
  categories: CategoryWithSelectedProduct[];
  eventPrefix?: EventPrefix;
}

export const trackPaymentFailed = ({
  user,
  categories,
  eventPrefix = EVENT_PREFIX.NONE,
}: TrackPaymentFailedParams) => {
  const totalPrice = calculateTotal(categories);

  triggerGoogleTagManagerTracking<GoogleTagManagerEventDetails>({
    event: `${eventPrefix}${GOOGLE_TAG_MANAGER_EVENT.PAYMENT_FAILED}`,
    ecommerce: {
      currency: CURRENCY.USD,
      value: totalPrice,
      items: categoriesToGoogleTagManagerProducts(categories),
    },
  });

  triggerCustomerIoOnboardingPaymentFailed({ user, categories, eventPrefix });
};
